import React, { useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import { useDispatch } from "react-redux";
import * as DataAction from "../../../../store/actions/data/DataAction";
const Credentials = ({
  formField,
  onTypeChange,
  onShiftHourChange,
  onDaySelect,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="w-[70%] mx-auto h-full">
      <div className="text-center h-[15%] flex flex-col justify-center">
        <ParagraphTag
          content="Shift Info"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <div>
          <ParagraphTag
            content="Add info"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
        </div>
      </div>
      <form className="overflow-y-scroll h-[75%] panelScroll px-1">
        <div className=" w-[65%] mx-auto">
          <div className="mt-3">
            <LabelTag
              isStaric={false}
              name="Type"
              classes="!text-xs !font-popinsMedium"
            />
            <select
              value={formField.type}
              onChange={(e) => {
                onTypeChange(e.target.value);
              }}
              className="block w-full bg-bgColor px-3 py-2 border border-gray-300 rounded-sm shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor sm:text-sm mt-1"
            >
              <option>community</option>
              <option>technical</option>
            </select>
          </div>
          <div className="mt-3">
            <LabelTag
              isStaric={false}
              name="Shift hours"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={formField.shoftHour}
              onChange={(e) => {
                onShiftHourChange(e.target.value);
              }}
              type="text"
              placeholder="Shift hours"
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
          <div className="mt-2">
            <LabelTag
              isStaric={false}
              name="How many days in a week"
              classes="!text-xs !font-popinsMedium"
            />
            <div className="flex justify-between mt-2">
              {formField?.schedule?.map((item) => (
                <div
                  onClick={() => {
                    onDaySelect(item.day);
                  }}
                  className={`px-3 ${
                    item.isSelected ? "bg-themeColor text-white" : null
                  }  mx-2 rounded-md bg-[#F4F4F4] text-darkColor/40 font-popinsRegular text-xs hover:bg-themeColor hover:text-white cursor-pointer py-2 text-center`}
                >
                  {item?.day}
                </div>
              ))}
            </div>
          </div>
        </div>
      </form>
      <div className="h-[10%] flex justify-center">
        <div className="w-[80%] mx-auto flex gap-4">
          <div className="w-[50%]">
            <ButtonTag
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(DataAction.SupportStaffStepsChangeAction(1));
              }}
              name="Back"
              classes="text-base text-center bg-gray-500 text-white"
            />
          </div>
          <div className="w-[50%]">
            <ButtonTag
              onSubmit={() => {
                dispatch(DataAction.SupportStaffStepsChangeAction(3));
              }}
              name="Next"
              classes="text-base text-center bg-themeColor text-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Credentials;
